"use client";

import { useEffect, useState, useMemo } from "react";
import PropTypes from "prop-types";
import { formatPhoneView } from "src/utils/ui";
import phoneMasking, { PHONE_MARKER } from "src/utils/ui/newPhoneMasking";
import Title from "components/listing-detail/title";
import MoreContent from "components/listing-detail/more-content";
import JetHatReveal from "@/src/components/jethat-reveal";
import styles from "./styles.module.css";

const Description = ({ data, jethat, listingId }) => {
  const [processedParts, setProcessedParts] = useState([]);
  const [isClient, setIsClient] = useState(false);

  const phoneNumber = useMemo(() => {
    if (!jethat) return "";
    return jethat.startsWith("+9") ? jethat.split("+9")[1] : jethat;
  }, [jethat]);
  const formattedJetHat = useMemo(() => formatPhoneView(phoneNumber), [phoneNumber]);

  const maskedDesc = useMemo(() => {
    if (jethat && (jethat.indexOf("850") >= 0 || jethat.indexOf("312") >= 0)) {
      return phoneMasking(data);
    }
    return data;
  }, [data, jethat]);

  const descParts = useMemo(() => maskedDesc.split(PHONE_MARKER), [maskedDesc]);

  const cleanHeadings = (html) =>
    html.replace(/<(h[1-3])([^>]*)>([\s\S]*?)<\/\1>/gi, (_, tag, attrs = "", content) => {
      const fontSizes = { h1: "2em", h2: "1.5em", h3: "1.17em" };
      const margins = { h1: "0.67em", h2: "0.83em", h3: "1em" };

      const cls = (attrs.match(/class\s*=\s*["']([^"']+)["']/i) || [, ""])[1];
      const rawStyle = (attrs.match(/style\s*=\s*["']([^"']+)["']/i) || [, ""])[1];

      const align = /\bql-align-center\b/.test(cls)
        ? "center"
        : /\bql-align-right\b/.test(cls)
        ? "right"
        : /\bql-align-justify\b/.test(cls)
        ? "justify"
        : "";

      const combinedStyle = [
        rawStyle,
        align && !/text-align/.test(rawStyle) ? `text-align:${align};` : "",
        `display:block; margin-block-start:${margins[tag]}; margin-block-end:${margins[tag]}; font-size:${fontSizes[tag]}; font-weight:bold;`,
      ]
        .filter(Boolean)
        .join(" ");

      return `<span${attrs.replace(/style\s*=\s*["'][^"']*["']/i, "")} style="${combinedStyle}">${content}</span>`;
    });

  useEffect(() => {
    setIsClient(true);
    const cleanedParts = descParts.map((part) => cleanHeadings(part));
    setProcessedParts(cleanedParts);
  }, [descParts]);

  const contentKey = useMemo(() => {
    return processedParts.length > 0 ? `content-${processedParts.join("").length}` : "initial";
  }, [processedParts]);

  return (
    <div className={styles.wrapper}>
      <Title>İlan Açıklaması</Title>
      <MoreContent key={contentKey} defaultHeight={251}>
        <div className={styles.inner}>
          {processedParts.map((part, idx) => (
            <span key={idx}>
              <span dangerouslySetInnerHTML={{ __html: part }} />
              {idx < processedParts.length - 1 && <JetHatReveal jethat={formattedJetHat} listingId={listingId} />}
            </span>
          ))}
        </div>
      </MoreContent>
    </div>
  );
};

Description.propTypes = {
  data: PropTypes.string,
  jethat: PropTypes.string,
  listingId: PropTypes.number,
};

export default Description;
